module.exports = __webpack_public_path__ + "media/theme/SP_HITW_open1-83125b7a.png";